import { authenticatedApiClient } from './axios';
import { Emoji } from '@cobu/types';

// Fetch building-specific custom emojis (legacy parity)
export async function fetchCustomEmojis(buildingUuid: string): Promise<Emoji[]> {
  // Old app: GET /building/emojis?buildingUuid=<id>
  if (!buildingUuid) return [];
  const response = await authenticatedApiClient.get<Emoji[]>(`/building/emojis`, {
    params: { buildingUuid },
  });
  return response || [];
}

export interface ReactToCommentInput {
  commentId: string;
  reactionName: string | null;
  isRemoving?: boolean;
  parentCommentId?: string;
  commentType?: 'groupComment' | 'groupEventComment';
}

// Thin wrappers that mirror commentsService endpoints if needed by local hooks
export async function addReaction({ commentId, reactionName, parentCommentId, commentType = 'groupComment' }: ReactToCommentInput): Promise<void> {
  let endpoint = `/v2/groupcomment/${commentId}/reaction`;
  if (commentType === 'groupEventComment') {
    endpoint = `/v2/groupeventcomment/${commentId}/reaction`;
  }
  const data: any = { reactionName: reactionName! };
  if (parentCommentId) data.parent = parentCommentId;
  await authenticatedApiClient.post<void>(endpoint, data);
}

export async function removeReaction({ commentId, parentCommentId, commentType = 'groupComment' }: ReactToCommentInput): Promise<void> {
  let endpoint = `/v2/groupcomment/${commentId}/reaction`;
  if (commentType === 'groupEventComment') {
    endpoint = `/v2/groupeventcomment/${commentId}/reaction`;
  }
  const params: any = {};
  if (parentCommentId) params.parent = parentCommentId;
  await authenticatedApiClient.delete<void>(endpoint, { params });
} 